export const SITE_URL = "https://willalwaysloveu.com";
export const SITE_NAME = "WillAlwaysLoveU";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/willalwaysloveu-favicon.png`;

export const DEFAULT_SEO = {
  title: "Online Memorial Service | Create a Memorial Website | WillAlwaysLoveU",
  description:
    "Create a beautiful online memorial for a loved one. Share photos, videos, tributes, and stories with family and friends across the United States.",
};
